var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.125 11.126a3.125 3.125 0 10-6.25-.002 3.125 3.125 0 006.25.002z",
    stroke: "#ED1B2E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11 24.25c-1.499 0-9.375-6.377-9.375-13.046 0-5.22 4.196-9.454 9.374-9.454 5.178 0 9.376 4.233 9.376 9.454 0 6.669-7.877 13.046-9.376 13.046z",
    stroke: "#ED1B2E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgLocationPin;